import { prop } from '@typegoose/typegoose';
import { ObjectId } from '@nirvana/shared/database/nestjs/mongo';
import mongoose from 'mongoose';

export class ScoreBreakdown {
  @prop()
  finalScore: number;

  @prop()
  baseScore: number;

  @prop()
  multiplier: object;
}

export class AffectedDevice {
  @prop()
  type: number;

  @prop()
  count: number;

  @prop({ required: true, type: mongoose.Types.ObjectId })
  ids: Array<mongoose.Types.ObjectId>;
}

export class AffectedUser {
  @prop()
  type: number;

  @prop()
  count: number;

  @prop({ required: true, type: mongoose.Types.ObjectId })
  ids: Array<mongoose.Types.ObjectId>;
}
